import FormErrors from './FormErrors';

export default class {
    constructor(data) {
        this.defaults = Object.assign({}, data);
        this.data = data;
        this.errors = new FormErrors();
    }

    updateData(entity) {
        for (let field in entity) {
            if (field in this.data)
                this.data[field] = entity[field];
        }
    }

    clearData() {
        Object.assign(this.data, this.defaults);
    }

    async save(method) {
        this.errors.clear();

        try {
            return await method();
        } catch (e) {
            if (e.response && e.response.status === 422) {
                e.isValidationError = true;
                this.errors.apply(e.response.data.errors);
            }

            throw e;
        }
    }
}
